import { AnyAction, configureStore, getDefaultMiddleware, ThunkDispatch } from '@reduxjs/toolkit';

import RootReducer from './RootReducer';

const store = configureStore({
  reducer: RootReducer,
  middleware: getDefaultMiddleware({}),
});

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./RootReducer', () => {
    const newRootReducer = RootReducer;
    store.replaceReducer(newRootReducer);
  });
}

export type AppDispatch = ThunkDispatch<ReturnType<typeof store.getState>, string, AnyAction>;

export default store;
